import { styled } from 'src/styles/stitches.config'

export const Wrapper = styled('div', {
    position: 'relative',
    paddingLeft: '70px',

    '&::before': {
        position: 'absolute',
        top: '50%',
        left: 0,
        transform: 'translateY(-4px)',
        content: '',
        width: '60px',
        height: '1px',
        backgroundColor: '$white',
    },
})
